<template>
  <div id="app">
    <Sidebar />
    <router-view class="content"></router-view>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue'
export default {
  components: {Sidebar},
  name: 'app'
}
</script>

<style>
body {
  margin: 0; overflow-x: hidden; 
}
#app {
  font-family: 'Open Sans Condensed', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  height: 100vh;
  width: 100vw;
}
.content {
  width: 100%;
  padding-left: 220px;
}
input::placeholder, textarea::placeholder {
  font-weight: bold;
  color: #CCC;
  font-family: 'Open Sans Condensed', Helvetica, Arial, sans-serif;
}
textarea {
  border: 0;
  width: 100%;
  resize: none;
  height: 100px;
  line-height: 1.2;
  padding: 15px;
  font-size: 12px;
  box-sizing: border-box;
  outline: none;
  font-family: 'Open Sans Condensed', Helvetica, Arial, sans-serif;
  font-weight: bold;
}
input, select {
  font-family: 'Open Sans Condensed', Helvetica, Arial, sans-serif;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  font-size: 12px;
  height: 42px;
  background: #FFF;
  border-radius: 0;
  font-weight: bold;
  outline: none;
  border: 0;
  margin-bottom: 10px;
}
.option select {
  width: 48px;
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// App.vue?2b1afa8e